import { Paper, PaperProps } from '@mui/material';

import { Dialog, DialogProps } from '..';


/**
 * Renders a mui dialog that contains form fields
 *
 * @param onSubmit   - The form submit handler
 * @param otherProps - Other props to spread down to the Dialog component
 * @constructor
 */
export function FormDialog({
    onSubmit, ...otherProps
}: DialogProps) {
    return (
        <Dialog
            PaperComponent={FormPaper}
            PaperProps={{
                ...otherProps.PaperProps,
                onSubmit
            }}
            {...otherProps}
        />
    );
}

/**
 * Custom Paper component for the Dialog that renders the Paper as a form.
 * The TS definition on PaperProps for the Dialog defaults to being a div
 * and there's no way to override it. Casting props to PaperProps<'form'>
 * here makes it happy.
 *
 * @param props - The props to spread onto the Paper component
 * @constructor
 */
function FormPaper(props: PaperProps) {
    const formPaperProps = props as PaperProps<'form'>;

    return (
        <Paper
            component="form"
            noValidate
            {...formPaperProps}
        />
    );
}
